
// External libraries
import Vue from 'vue'
import { mapState } from 'vuex'
import {
    buildCanonicalUrl,
    buildSeoMeta,
    buildSeoTitle,
    formatSeoText,
    getRuntimeSeoConfig,
    stripHtmlForSeo
} from '@/helpers/seoMetaHelper'

export default Vue.extend({
    metaInfo: function() {
        const partnerSettings = (this as any).partnerSettings || {}
        const vueAppConfig = getRuntimeSeoConfig()
        const selectedPage = (this as any).selectedPage || {}
        const routeParams = this.$route.params || {}

        const partnerName = partnerSettings.partnerName || vueAppConfig.VUE_APP_Title || 'Online Store'
        const pageName = selectedPage.name || formatSeoText(routeParams.footerPageName) || 'Information'
        const title = buildSeoTitle({
            primary: pageName,
            siteName: partnerName,
            descriptor: 'Information'
        })
        const description =
            stripHtmlForSeo(selectedPage.htmlValue || '') ||
            `${pageName} information from ${partnerName}.`
        const image =
            partnerSettings.seoImageUrl ||
            partnerSettings.appBarLogoUrl ||
            partnerSettings.logoUrl ||
            ''

        return buildSeoMeta({
            title,
            description,
            keywords: partnerSettings.seoKeywords || vueAppConfig.VUE_APP_Meta_Keywords || '',
            image,
            canonicalUrl: buildCanonicalUrl(this)
        })
    },

    computed: {
        // Map the selectedPage from Vuex
        ...mapState('footerModule', ['selectedPage']),
        ...mapState('partner', ['partnerSettings']),
    },
    watch: {
        // Watch for changes in selectedPage to dynamically update CSS
        selectedPage: {
            handler(newPage) {
            if (newPage && newPage.cssValue) {
                this.injectCss(newPage.cssValue)
            }
            },
            immediate: true,
        },
    },
    methods: {
        // Dynamically inject CSS into the document's head (and scoping it)
        injectCss(cssCode: string) {
            if (typeof document === 'undefined') {
                return
            }

            const prefix = '#scoped-container'
            
            // Prefix each CSS selector to scope it
            const scopedCss = cssCode.replace(/(^|\s)([^\s{}]+)(?=\s*{)/g, `$1${prefix} $2`)
            
            // Remove previously injected styles
            const existingStyleTag = document.getElementById('dynamic-css')
            if (existingStyleTag) {
                existingStyleTag.remove()
            }
            
            // Create and append a new style tag
            const styleTag = document.createElement('style')
            styleTag.id = 'dynamic-css'
            styleTag.type = 'text/css'
            styleTag.appendChild(document.createTextNode(scopedCss))
            document.head.appendChild(styleTag)
        }
    },
    beforeDestroy() {
        if (typeof document === 'undefined') {
            return
        }

        // Remove previously injected styles
        const existingStyleTag = document.getElementById('dynamic-css')
        if (existingStyleTag) {
            existingStyleTag.remove()
        }
    }
})
